import { useTranslation } from 'react-i18next'
import styles from './index.module.less'
import classNames from 'classnames'
import { IResAgePledgeListItem } from '@/api/account/interface'
import { getFormatTimeZone } from '@/utils'
import { ugagToGag, ugeaToGea2 } from '@/utils/number'
const AgeCard = (props: IResAgePledgeListItem) => {
  const { t } = useTranslation()
  const startTime = getFormatTimeZone(props.startTime.replace(/-/g, '/').replace(' UTC', ''))
  const delegateEndTime = getFormatTimeZone(
    props.delegateEndTime.replace(/-/g, '/').replace(' UTC', ''),
  )
  const lockupInterestEndTime = getFormatTimeZone(
    props.lockupInterestEndTime.replace(/-/g, '/').replace(' UTC', ''),
  )
  const amount = ugeaToGea2(props.amount)
  const delegateInterest = ugeaToGea2(props.delegateInterest)
  const delegateInterestGag = ugagToGag(props.delegateInterest)
  const lockupInterest = ugeaToGea2(props.lockupInterest)
  const lockupInterestGag = ugagToGag(props.lockupInterest)
  return (
    <div className={styles.wrapBox}>
      <div className={styles.wrap}>
        <div>
          {/* 质押时间 */}
          <div className={styles.title}>{t('explorer_203')}</div>
          <div className={styles.textStyleFive}>
            <div className="font_14">
              <span>{startTime.timeUtc0}</span>
              <span
                className={classNames({
                  [styles.textStyleFour]: true,
                  font_14: true,
                })}
              >
                （UTC+0）
              </span>
            </div>
            <div>
              {startTime.currentTime}
              <span
                className={classNames({
                  [styles.textStyleFour]: true,
                  font_14: true,
                })}
              >
                （{t('explorer_95')}）
              </span>
            </div>
          </div>
        </div>
        <div>
          {/* 数量 */}
          <div className={styles.title}>{t('explorer_105')}</div>
          <div className={styles.textStyleTwo}>
            <span className={'font_14'}>{amount.value}</span>{' '}
            <span className={classNames(styles.textStyleThree, 'font_14')}>{amount.sigin}</span>
          </div>
        </div>
        {/* <div> */}
        {/* 待提取灵活期限奖励 */}
        {/* <div className={styles.title}>{t('explorer_207')}</div>
          <div className={styles.textStyleTwo}>
            <span>{delegateInterest.value}</span>{' '}
            <span className={styles.textStyleThree}>{delegateInterest.sigin}</span>
          </div> */}
        {/* <div className={styles.title}>{t('explorer_207')}</div>
          <div className={classNames(styles.textStyleFive, 'font_14')}>
            <div>
              <span>{delegateInterest.value} </span>
              <span className={styles.textStyleFour}>{delegateInterest.sigin}</span>
            </div>
            <div>
              <span>{delegateInterestGag.value} </span>
              <span className={styles.textStyleFour}>{delegateInterestGag.sigin}</span>
            </div>
          </div> */}
        {/* </div> */}
        <div>
          {/* 质押到期时间 */}
          <div className={styles.title}>{t('explorer_208')}</div>
          <div className={classNames(styles.textStyleFive, 'font_14')}>
            <div>
              <span>{delegateEndTime.timeUtc0}</span>
              <span className={styles.textStyleFour}>（UTC+0）</span>
            </div>
            <div>
              {/* （当前时区） */}
              {delegateEndTime.currentTime}
              <span className={styles.textStyleFour}>（{t('explorer_95')}）</span>
            </div>
          </div>
        </div>
        <div>
          {/* 待提取锁仓质押奖励 */}
          {/* <div className={styles.title}>{t('explorer_209')}</div>
          <div className={styles.textStyleTwo}>
            <span>{lockupInterest.value}</span>{' '}
            <span className={styles.textStyleThree}>{lockupInterest.sigin}</span>
          </div> */}
          <div className={styles.title}>{t('explorer_209')}</div>
          <div className={classNames(styles.textStyleFive, 'font_14')}>
            <div>
              <span>{lockupInterest.value} </span>
              <span className={styles.textStyleFour}>{lockupInterest.sigin}</span>
            </div>
            <div>
              <span>{lockupInterestGag.value} </span>
              <span className={styles.textStyleFour}>{lockupInterestGag.sigin}</span>
            </div>
          </div>
        </div>
        <div>
          {/* 锁仓奖励到期时间 */}
          <div className={styles.title}>{t('explorer_210')}</div>
          <div className={classNames(styles.textStyleFive, 'font_14')}>
            <div>
              {lockupInterestEndTime.timeUtc0}
              <span className={styles.textStyleFour}>（UTC+0）</span>
            </div>
            <div>
              {lockupInterestEndTime.currentTime}
              <span className={styles.textStyleFour}>（{t('explorer_95')}）</span>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.mobileWrap}>
        <div className="area_a">
          {/* 数量 */}
          <div className={styles.title}>{t('explorer_105')}</div>
          <div className={classNames(styles.textStyleTwo, 'font_14')}>
            <span>{amount.value}</span>{' '}
            <span className={classNames(styles.textStyleThree, 'font_14')}>{amount.sigin}</span>
          </div>
        </div>
        {/* <div className="area_b">
          待提取灵活期限奖励
          <div className={styles.title}>{t('explorer_207')}</div>
          <div className={classNames(styles.textStyleTwo, 'font_14')}>
            <span>{delegateInterest.value}</span>{' '}
            <span className={classNames(styles.textStyleThree, 'font_14')}>
              {delegateInterest.sigin}
            </span>
          </div>
          <div className={classNames(styles.textStyleTwo, 'font_14')}>
            <span>{delegateInterestGag.value}</span>{' '}
            <span className={classNames(styles.textStyleThree, 'font_14')}>
              {delegateInterestGag.sigin}
            </span>
          </div>
        </div> */}
        <div className="area_b">
          {/* 待提取锁仓质押奖励 */}
          <div className={styles.title}>{t('explorer_209')}</div>
          <div className={classNames(styles.textStyleTwo, 'font_14')}>
            <span>{lockupInterest.value}</span>{' '}
            <span className={classNames(styles.textStyleThree, 'font_14')}>
              {lockupInterest.sigin}
            </span>
          </div>
          <div className={classNames(styles.textStyleTwo, 'font_14')}>
            <span>{lockupInterestGag.value}</span>{' '}
            <span className={classNames(styles.textStyleThree, 'font_14')}>
              {lockupInterestGag.sigin}
            </span>
          </div>
        </div>
        <div className="area_c">
          {/* 质押时间 */}
          <div className={styles.title}>{t('explorer_203')}</div>
          <div className={classNames(styles.textStyleFive, 'font_14')}>
            <div>
              <span>{startTime.timeUtc0}</span>
              <span className={classNames(styles.textStyleFour, 'font_14')}>(UTC+0)</span>
            </div>
            <div>
              <span>{startTime.currentTime} </span>
              {/* （当前时区） */}
              <span className={classNames(styles.textStyleFour, 'font_14')}>
                ({t('explorer_95')})
              </span>
            </div>
          </div>
        </div>
        <div className="area_d">
          {/* 质押到期时间 */}
          <div className={styles.title}>{t('explorer_208')}</div>
          <div className={classNames(styles.textStyleFive, 'font_14')}>
            <div>
              <span>{delegateEndTime.timeUtc0}</span>
              <span className={classNames(styles.textStyleFour, 'font_14')}>(UTC+0)</span>
            </div>
            <div>
              <span>{delegateEndTime.currentTime}</span> {/* （当前时区） */}
              <span className={classNames(styles.textStyleFour, 'font_14')}>
                ({t('explorer_95')})
              </span>
            </div>
          </div>
        </div>
        <div className="area_e">
          {/* 锁仓奖励到期时间 */}
          <div className={styles.title}>{t('explorer_210')}</div>
          <div className={classNames(styles.textStyleFive, 'font_14')}>
            <div>
              <span>{lockupInterestEndTime.timeUtc0}</span>
              <span className={classNames(styles.textStyleFour, 'font_14')}>(UTC+0)</span>
            </div>
            <div>
              <span>{lockupInterestEndTime.currentTime}</span>
              {/* （当前时区） */}
              <span className={classNames(styles.textStyleFour, 'font_14')}>
                ({t('explorer_95')})
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AgeCard
